import { dialogClasses } from "@mui/material";
import { createTheme } from "../../../../constants/create-theme/create-theme.js";
import { MuiDateCalendar } from "../../../../themes/date-calendar/date-calendar.js";
import { MuiDatePickerToolbar } from "../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import { MuiDayCalendar } from "../../../../themes/day-calendar/day-calendar.js";
import { MuiFilledInput } from "../../../../themes/filled-input/filled-input.js";
import { MuiFormHelperText } from "../../../../themes/form-helper-text/form-helper-text.js";
import { MuiFormLabel } from "../../../../themes/form-label/form-label.js";
import { MuiMonthCalendar } from "../../../../themes/month-calendar/month-calendar.js";
import { MuiPickersArrowSwitcher } from "../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import { MuiPickersCalendarHeader } from "../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import { MuiPickersDay } from "../../../../themes/pickers-day/pickers-day.js";
import { MuiPickersMonth } from "../../../../themes/pickers-month/pickers-month.js";
import { MuiPickersPopper } from "../../../../themes/pickers-popper/pickers-popper.js";
import { MuiPickersToolbar } from "../../../../themes/pickers-toolbar/pickers-toolbar.js";
import { MuiPickersYear } from "../../../../themes/pickers-year/pickers-year.js";
import { MuiYearCalendar } from "../../../../themes/year-calendar/year-calendar.js";
import "@mui/material/styles";
import "../../../../constants/colors/palette.js";
import "../../../../themes/shadows/shadows.js";
import "../../../../themes/typography/typography.js";
import "../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "color-alpha";
import "@mui/x-date-pickers";
const theme = createTheme({
  variant: "internal",
  components: {
    MuiFilledInput,
    MuiFormHelperText,
    MuiFormLabel,
    MuiPickersDay,
    MuiPickersYear,
    MuiPickersMonth,
    MuiPickersPopper,
    MuiPickersArrowSwitcher,
    MuiPickersCalendarHeader,
    MuiPickersToolbar,
    MuiDayCalendar,
    MuiMonthCalendar,
    MuiYearCalendar,
    MuiDatePickerToolbar,
    MuiDateCalendar,
    MuiDialog: {
      styleOverrides: {
        root: {
          [`.${dialogClasses.paper}`]: {
            minWidth: "328px !important",
            borderRadius: "16px"
          }
        }
      }
    }
  }
});
export {
  theme
};
